import { PageHero, Reveal } from "../components/Reveal";
import { CONTACT, LEGAL } from "../data/site";
import useSeo from "../components/Seo";

function LegalLayout({ overline, title, children }) {
  return (
    <>
      <PageHero overline={overline} lines={[title]} />
      <section className="py-24" data-testid={`${overline.toLowerCase().replace(/\s+/g, "-")}-content`}>
        <Reveal className="mx-auto max-w-3xl space-y-8 px-6 text-sm leading-relaxed text-muted-foreground lg:px-10">
          {children}
        </Reveal>
      </section>
    </>
  );
}

export function Privacy() {
  useSeo("Privacy Policy", "Privacy Policy of The Royal Mahaveer Roadlines Pvt Ltd.");
  return (
    <LegalLayout overline="Legal" title={<>Privacy <em className="italic text-gold-light">Policy</em></>}>
      <p>
        The Royal Mahaveer Roadlines Pvt Ltd (“the Company”, “we”, “us”) respects the privacy
        of every visitor and customer. This policy explains how information submitted through this
        website is handled.
      </p>
      <h2 className="font-heading text-xl text-foreground">Information we collect</h2>
      <p>
        When you submit an enquiry or quotation request, we collect the details you provide — such as
        your name, company name, phone number, email address, pickup and delivery locations, and cargo
        information — solely for the purpose of responding to your request.
      </p>
      <h2 className="font-heading text-xl text-foreground">How we use it</h2>
      <p>
        Information you submit is used only to coordinate and respond to your transportation enquiry.
        We do not sell, rent or share your personal information with third parties for marketing purposes.
      </p>
      <h2 className="font-heading text-xl text-foreground">Data retention</h2>
      <p>
        Enquiry records are retained for operational and record-keeping purposes. You may request
        correction or deletion of your submitted information by writing to us at {CONTACT.email}.
      </p>
      <h2 className="font-heading text-xl text-foreground">Contact</h2>
      <p>
        For any privacy-related question, contact us at {CONTACT.email} or write to our registered
        office: {LEGAL.registeredOffice}.
      </p>
    </LegalLayout>
  );
}

export function Terms() {
  useSeo("Terms & Conditions", "Terms and Conditions of The Royal Mahaveer Roadlines Pvt Ltd website.");
  return (
    <LegalLayout overline="Legal" title={<>Terms &amp; <em className="italic text-gold-light">Conditions</em></>}>
      <p>
        By using this website, you agree to the following terms. The content of this website is
        provided by The Royal Mahaveer Roadlines Pvt Ltd for general information about our
        road transportation and logistics services.
      </p>
      <h2 className="font-heading text-xl text-foreground">Information accuracy</h2>
      <p>
        We take care to keep the information on this website accurate and current. Service
        availability, routes and vehicle allocation are confirmed individually at the time of enquiry;
        nothing on this website constitutes a binding quotation.
      </p>
      <h2 className="font-heading text-xl text-foreground">Enquiries</h2>
      <p>
        Submitting an enquiry through this website does not create a contract of carriage. A
        transportation engagement is formed only after written confirmation of scope, route, schedule
        and commercial terms by the Company.
      </p>
      <h2 className="font-heading text-xl text-foreground">Intellectual property</h2>
      <p>
        The name, emblem and content of this website are the property of The Royal Mahaveer Roadlines
        Pvt Ltd and may not be reproduced without written permission.
      </p>
      <h2 className="font-heading text-xl text-foreground">Jurisdiction</h2>
      <p>
        These terms are governed by the laws of India. Any dispute is subject to the jurisdiction of
        the courts of Bengaluru, Karnataka.
      </p>
    </LegalLayout>
  );
}
